import { Pipe, PipeTransform } from '@angular/core';
import {
    DomSanitizer,
    SafeStyle,
    SafeResourceUrl,
    SafeScript,
    SafeHtml,
    SafeUrl
} from '@angular/platform-browser';
import { SafeType } from '../enum/safe-type.enum';

@Pipe({
    name: 'safe-type'
})
export class SafeTypePipe implements PipeTransform {
    /**
     * Creates an instance of safe type pipe.
     * @param sanitizer DomSanitizer
     */
    public constructor(protected sanitizer: DomSanitizer) { }
    /**
     * Transforms safe type pipe
     * @param value string
     * @param type SafeType
     * @returns SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl
     */
    public transform(value: string, type: SafeType): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {

        switch (type) {
            case SafeType.HTML:
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case SafeType.STYLE:
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case SafeType.SCRIPT:
                return this.sanitizer.bypassSecurityTrustScript(value);
            case SafeType.URL:
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case SafeType.RESOURCE:
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`SafePipe unable to bypass security for invalid type: ${type}`);
        }
    }

}
